import { isValid } from "date-fns";
import { z } from "zod";

export const AddVehicleByVinResponseSchema = z
	.object({
		data: z
			.array(
				z
					.object({
						brand: z.enum(["L", "T"]),
						make: z.enum(["LEXUS", "TOYOTA"]),
						model: z.string(),
						modelYear: z.string().refine((x) => isValid(new Date(x))),
						vehicleId: z.string(),
						vin: z.string(),
						yearMakeModel: z.string(),
					})
					.refine(
						(data) => data.vehicleId === data.vin,
						"VehicleId must match VIN.",
					),
			)
			.length(1),
	})
	.transform(({ data }) => data);

export const AddVehicleByModelYearResponseSchema = z
	.object({
		data: z
			.array(
				z.object({
					brand: z.enum(["L", "T"]),
					make: z.enum(["LEXUS", "TOYOTA"]),
					model: z.string(),
					modelYear: z.string().refine((x) => isValid(new Date(x))),
					vehicleId: z.string(),
					yearMakeModel: z.string(),
				}),
			)
			.length(1),
	})
	.transform(({ data }) => data);
